import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { Gem, Heart, Sun, Wind } from 'lucide-react';

const PathsSection = () => {
  const { t, isRTL } = useLanguage();

  const icons = {
    crystal: Gem,
    heart: Heart,
    sun: Sun,
    wind: Wind
  };

  return (
    <section className="section-padding bg-charcoal-100 relative">
      {/* Yellow accent line at top */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent" />
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-10">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-10 sm:mb-16">
          <p className="text-gold text-xs sm:text-sm uppercase tracking-[0.2em] sm:tracking-[0.3em] mb-3 sm:mb-4 font-medium">
            {t.paths.tagline}
          </p>
          <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl xl:text-5xl text-gold leading-tight mb-4 sm:mb-6 px-2">
            {t.paths.headline}
          </h2>
          <div className="gold-divider" />
          <p className="text-cream-300 mt-6 sm:mt-8 text-base sm:text-lg px-4">
            {t.paths.description}
          </p>
        </div>

        {/* Paths Grid - 2 columns on mobile, 4 on desktop */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6 lg:gap-8">
          {t.paths.items.map((path, index) => {
            const Icon = icons[path.icon] || Gem;
            return (
              <div
                key={path.id}
                className="premium-card p-4 sm:p-6 lg:p-8 text-center group cursor-pointer relative overflow-hidden rounded-xl"
              >
                {/* Hover glow effect */}
                <div className="absolute inset-0 bg-gradient-to-b from-gold/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-xl" />
                
                {/* Icon */}
                <div className="relative w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 mx-auto mb-4 sm:mb-6 border-2 border-gold/40 flex items-center justify-center group-hover:border-gold group-hover:bg-gold/10 transition-all duration-300 rounded-xl">
                  <Icon size={20} className="text-gold sm:hidden" />
                  <Icon size={24} className="text-gold hidden sm:block lg:hidden" />
                  <Icon size={26} className="text-gold hidden lg:block" />
                </div>

                {/* Title */}
                <h3 className="relative font-serif text-base sm:text-lg lg:text-xl text-gold mb-2 sm:mb-4">
                  {path.title}
                </h3>

                {/* Description - Hide on very small screens */}
                <p className="relative text-cream-300 text-xs sm:text-sm leading-relaxed hidden xs:block">
                  {path.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PathsSection;